<template>
  <div>
    <ValidationObserver
      ref="form"
      v-slot="{ invalid, handleSubmit }"
    >
      <form
        id="myForm"
        @submit.prevent="handleSubmit(onSubmit)"
      >
        <fieldset
          v-for="(group, groupIndex) in structure"
          :key="`group-${groupIndex}`"
        >
          <p class="text-2xl font-bold my-4">
            {{ group.groupName }}
          </p>
          <label
            v-for="(input, inputIndex) in group.inputs"
            :key="`group-${groupIndex}-${inputIndex}`"
          >
            <span class="block text-lg mt-6 mb-0 p-0">{{ input.label }}</span>
            <div
              v-if="input.type === 'file'"
              class="px-10 py-5 rounded-lg border border-dashed border-gray-400 text-center cursor-pointer"
            >
              <eva-icon
                v-if="!fileLoaded"
                name="upload-outline"
                color="white"
                fill="#C4C4C4"
                width="48"
                height="48"
              />
              <img
                v-else
                ref="outputImage"
                class="w-64 h-64 mx-auto rounded-full object-scale-down shadow-inner"
              >
            </div>
            <ValidationProvider
              v-slot="{ errors, validate }"
              :vid="input.id"
              :name="input.label"
              :rules="input.validation || ''"
            >
              <input
                v-if="input.type==='file'"
                type="file"
                accept="image/*"
                :name="input.id"
                :class="getClass(input.type)"
                @change="previewImage($event, input.id, validate)"
              >
              <input
                v-else
                :name="input.id"
                :type="input.type"
                :class="getClass(input.type)"
                :value="values[input.id]"
                @input="values[input.id] = $event.target.value"
                @change="values[input.id] = $event.target.value.trim()"
              >
              <p class="bg-red-400 text-lg text-center rounded-b-lg mx-1">{{ errors[0] }}</p>
            </ValidationProvider>
          </label>
        </fieldset>
        <button
          type="submit"
          :disabled="invalid"
          class="disabled:opacity-25 disabled:pointer-events-none block w-56 h-16 leading-16 bg-purple-500 text-white text-center text-2xl rounded-lg mx-auto mt-8"
        >
          {{ submitText }}
        </button>
      </form>
    </ValidationObserver>
    <portal to="modals">
      <modal
        :open="openModal"
        type="preloader"
        @close="openModal = false"
      >
        <div slot="content">
          <p class="text-lg text-center">
            Enviando formulario...
          </p>
        </div>
      </modal>
    </portal>
  </div>
</template>

<script>
import * as axios from 'axios'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { mapState } from 'vuex'
import Modal from '../components/modal'
export default {
  components: {
    Modal,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    preloadValues: {
      type: Object,
      default: () => {},
    },
    extraLoad: {
      type: Object,
      default: () => {},
    },
    structure: {
      type: Array,
      default: () => [],
    },
    submitText: {
      type: String,
      default: 'Guardar',
    },
    action: {
      type: String,
      default: 'echo',
    },
  },
  data () {
    return {
      values: {},
      files: {},
      fileLoaded: false,
      openModal: false,
    }
  },
  computed: {
    ...mapState({
      uid: state => state.auth.uid,
    }),
  },
  mounted () {
    this.values = this.preloadValues
  },
  methods: {
    async previewImage (event, inputID, validate) {
      const result = await validate()
      if (!result.valid) return
      const reader = new FileReader()
      reader.onload = () => {
        this.fileLoaded = true
        this.$nextTick(() => {
          this.$refs.outputImage[0].src = reader.result
        })
      }
      reader.readAsDataURL(event.target.files[0])
      this.files[inputID] = event.target.files[0]
    },
    async onSubmit () {
      this.openModal = true
      const fData = new FormData(document.getElementById('myForm'))
      fData.append('uid', this.uid)
      if (Object.keys(this.extraLoad).length) {
        for (const loadKey of Object.keys(this.extraLoad)) {
          fData.append(loadKey, this.extraLoad[loadKey])
        }
      }
      try {
        const response = await axios({
          url: this.action,
          method: 'POST',
          headers: { 'Content-Type': 'multipart/form-data' },
          data: fData,
        })
        this.openModal = false
        this.$emit('response', response)
      } catch (err) {
        this.openModal = false
        if (err.response) {
          // client received an error response (5xx, 4xx)
          this.$emit('error', err.response)
        } else if (err.request) {
          // client never received a response, or request never left
          this.$emit('error', err.request)
        } else {
          // anything else
          this.$emit('error', err)
        }
      }
    },
    getClass (type) {
      const classes = 'rounded-lg w-full text-2xl border border-gray-400 focus:bg-gray-200'
      switch (type) {
        case 'text':
          return classes + ' p-2'
        case 'number':
          return classes + ' p-2'
        case 'email':
          return classes + ' p-2'
        case 'file':
          return 'absolute w-5/12 invisible pointer-events-none'
        default:
          return ''
      }
    },
  },
}
</script>
